import { showDialog } from '@adornis/dialog/dialog-functions.js';
import { TextInput } from '@adornis/formfield/fields/text-input.js';
import { stateful, useState } from '@adornis/functional-lit/stateful.js';
import { useGeneratedForm } from '@adornis/generated-form/use-generated-form.js';
import { html } from 'lit';
import { SmartTeamsCompany } from '../../db/index.js';

const CreateCompanyForm = stateful((props: { onSubmit: (data: SmartTeamsCompany) => void; onCancel: () => void }) => {
  const [initialDocument] = useState(new SmartTeamsCompany({}));

  const { form, renderField } = useGeneratedForm<SmartTeamsCompany>(initialDocument, {
    validator: SmartTeamsCompany.prototype.validator.functions,
  });
  const { document, field, validate } = form;

  return html`
    <div class="flex flex-col gap-4">
      <h3 class="text-lg font-bold">Create new Partner Company</h3>

      <label class="form-control w-full">
        <div class="label"><span class="label-text">Name *</span></div>
        ${TextInput({ ...field('name'), placeholder: 'e.g. Acme Field Services Ltd.' })}
      </label>

      ${renderField(['address'])}

      <div class="flex justify-end gap-2 mt-2">
        <button class="btn btn-ghost" @click=${props.onCancel}>Cancel</button>
        <button
          class="btn btn-primary"
          @click=${async () => {
            const error = await validate();
            if (error) return;
            props.onSubmit(document);
          }}
        >
          Create
        </button>
      </div>
    </div>
  `;
});

/**
 * Shows a dialog to create a new company.
 * Returns the new company's ID if created, or null if cancelled.
 */
export async function showCreatePartnerCompanyDialog(): Promise<string | null> {
  const company = await showDialog<SmartTeamsCompany | null>({
    modalBoxClasses: 'max-w-lg',
    content: (ok, cancel) => CreateCompanyForm({ onSubmit: ok, onCancel: () => cancel() }),
  }).catch(() => null);

  if (!company) return null;

  const newId = await company.create?.();
  return newId ?? null;
}
